import { useFeatureFlag } from '@eggplant/routing'
import type { ReactNode } from 'react'
import { PreviewFeatureContextConsumer } from '../../PreviewFeatureContext/PreviewFeatureContext'

interface Props {
  children: ReactNode
  previewFeaturePlaceholder?: ReactNode
}

const PreviewFeatureControl = ({
  children,
  previewFeaturePlaceholder
}: Props) => {
  const [isUrlFeatureEnabled] = useFeatureFlag() // for cypress to enable preview feature in test

  const isCypressEnv = import.meta.env.VITE_IS_AUTH_DISABLED === 'true'

  const enableFeatureInTest = isCypressEnv && isUrlFeatureEnabled

  const renderChildren = (isPreviewFeatureEnabled: boolean) => {
    if (!isPreviewFeatureEnabled && previewFeaturePlaceholder) return previewFeaturePlaceholder

    return (isPreviewFeatureEnabled || enableFeatureInTest) && children
  }

  return (
    <PreviewFeatureContextConsumer>
      {
        ({ isPreviewFeatureEnabled }) =>
          renderChildren(isPreviewFeatureEnabled === '1')
      }
    </PreviewFeatureContextConsumer>
  )
}

export default PreviewFeatureControl
